// Multi-step wizards and modal-like flows that reuse a single URL across
// their whole session (Create.js never changes the route between steps,
// Email/ShareLink always resolve back to the float). Landing "back" on one
// of these either shows stale data or unexpectedly resumes a half-finished
// flow, so useContextualBack treats them as if there were no previous page.
const TRANSIENT_PATTERNS = [
  /^\/floats\/create(\/|$)/,
  /^\/floats\/[^/]+\/edit(\/|$)/,
  /^\/floats\/[^/]+\/email(\/|$)/,
  /^\/floats\/[^/]+\/share(\/|$)/,
  /^\/submissions\/create(\/|$)/,
  /^\/submissions\/[^/]+\/edit(\/|$)/,
  /^\/submissions\/[^/]+\/email(\/|$)/,
  /^\/submissions\/[^/]+\/share(\/|$)/,
];

export default function isTransientPath(path) {
  if (!path) return false;
  const pathname = path.split("?")[0];
  return TRANSIENT_PATTERNS.some((pattern) => pattern.test(pathname));
}
